import { render, staticRenderFns } from "./studentExamResult.vue?vue&type=template&id=28887fe4&scoped=true"
import script from "./studentExamResult.vue?vue&type=script&lang=js"
export * from "./studentExamResult.vue?vue&type=script&lang=js"
import style0 from "./studentExamResult.vue?vue&type=style&index=0&id=28887fe4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28887fe4",
  null
  
)

export default component.exports